// extracted by mini-css-extract-plugin
module.exports = {"searchNameBox":"_3n0QtPDc","wrapper":"_1utRh4zh","editUiContent":"_1B9HU8Au","container":"_1X-NoFGg","titleBox":"_2S_y2YnM"};